var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiCloudVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 378,
    viewBox: "0 0 471 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2214_12086)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 463,
    height: 370,
    rx: 24,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 144.829L105.565 131.787L128.155 118.744L150.746 131.787L128.156 144.829Z",
    fill: "#7DC3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.157 136.753C127.86 136.753 127.564 136.676 127.299 136.523L104.708 123.48C104.176 123.173 103.849 122.606 103.849 121.993C103.849 121.38 104.177 120.812 104.708 120.506L127.298 107.464C127.829 107.157 128.484 107.157 129.015 107.464L151.606 120.507C152.137 120.814 152.465 121.381 152.465 121.994C152.465 122.607 152.137 123.175 151.606 123.481L129.016 136.523C128.75 136.676 128.454 136.753 128.157 136.753ZM109.001 121.992L128.157 133.052L147.312 121.993L128.156 110.934L109.001 121.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.746 111.802L128.156 124.844V98.7595L150.746 85.7175V111.802Z",
    fill: "url(#paint0_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 98.7595L105.566 85.7175L128.155 72.6755L150.745 85.7175L128.156 98.7595Z",
    fill: "url(#paint1_linear_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.156 124.844L105.566 111.802V85.7175L128.156 98.7595V124.844Z",
    fill: "url(#paint2_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.021 110.753L113.703 107.105V99.8086L120.021 103.457V110.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5978 341.052L55.0078 328.01L77.5978 314.967L100.188 328.01L77.5978 341.052Z",
    fill: "#7DC3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.598 332.976C77.301 332.976 77.005 332.899 76.74 332.746L54.15 319.704C53.619 319.397 53.291 318.83 53.291 318.217C53.291 317.604 53.618 317.036 54.15 316.73L76.74 303.687C77.271 303.38 77.926 303.38 78.457 303.687L101.047 316.73C101.579 317.037 101.906 317.604 101.906 318.217C101.906 318.83 101.578 319.398 101.047 319.704L78.457 332.746C78.19 332.898 77.895 332.976 77.598 332.976ZM58.442 318.216L77.597 329.275L96.752 318.216L77.597 307.156L58.442 318.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.188 308.025L77.5977 321.067V294.983L100.188 281.941V308.025Z",
    fill: "url(#paint3_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5978 294.983L55.0078 281.941L77.5978 268.899L100.187 281.941L77.5978 294.983Z",
    fill: "url(#paint4_linear_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5978 321.067L55.0078 308.025V281.941L77.5978 294.983V321.067Z",
    fill: "url(#paint5_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4615 306.976L63.1436 303.328V296.032L69.4615 299.68V306.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.539 298.014L332.374 280.021C330.461 278.917 330.701 276.988 332.91 275.713L363.002 258.339C365.211 257.064 368.552 256.925 370.464 258.03L401.628 276.023C403.541 277.127 403.301 279.056 401.092 280.331L371 297.705C368.793 298.98 365.452 299.118 363.539 298.014Z",
    fill: "#7DC3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.796 290.691C365.273 290.691 363.804 290.363 362.654 289.7L331.489 271.708C330.105 270.909 329.312 269.668 329.313 268.303C329.313 266.776 330.301 265.328 332.025 264.333L362.117 246.959C364.902 245.354 368.871 245.22 371.349 246.651L402.513 264.642C403.897 265.441 404.69 266.682 404.689 268.047C404.689 269.574 403.702 271.022 401.978 272.017L371.885 289.39C370.393 290.253 368.559 290.691 366.796 290.691ZM367.241 249.203C366.079 249.203 364.823 249.485 363.887 250.025L333.795 267.399C333.039 267.835 332.857 268.23 332.853 268.304C332.864 268.325 332.965 268.471 333.26 268.642L364.425 286.634C365.799 287.427 368.46 287.282 370.116 286.324L400.208 268.95C400.964 268.514 401.146 268.119 401.15 268.045C401.139 268.024 401.038 267.878 400.743 267.707L369.579 249.716C368.981 249.371 368.139 249.203 367.241 249.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.911 257.021V246.268L378.799 246.255L370.465 241.443C368.552 240.339 365.211 240.477 363.003 241.752L355.227 246.241L331.094 246.227V257.286C331.039 258.033 331.456 258.755 332.375 259.285L363.54 277.278C365.453 278.382 368.794 278.244 371.002 276.969L401.094 259.595C402.368 258.861 402.983 257.908 402.911 257.021Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.003 240.703C365.603 240.737 364.151 241.09 363.003 241.752L355.227 246.241L331.094 246.227V257.286C331.039 258.033 331.456 258.755 332.375 259.285L363.54 277.278C364.459 277.809 365.708 278.049 367.003 278.018V240.703Z",
    fill: "url(#paint6_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.825 246.23L331.094 246.229V257.289C331.039 258.036 331.456 258.758 332.375 259.288L333.825 260.125V246.23Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.02 277.514C365.67 278.221 368.056 278.181 369.985 277.446V264.889H364.02V277.514Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.539 266.26L332.374 248.267C330.461 247.163 330.701 245.234 332.91 243.959L363.002 226.585C365.211 225.31 368.552 225.171 370.464 226.276L401.628 244.269C403.541 245.373 403.301 247.302 401.092 248.577L371 265.951C368.793 267.226 365.452 267.365 363.539 266.26Z",
    fill: "url(#paint7_linear_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.094 246.461L371.002 263.835C368.794 265.11 365.453 265.249 363.54 264.144L332.375 246.151C331.949 245.905 331.635 245.616 331.421 245.304C330.764 246.362 331.062 247.509 332.375 248.267L363.54 266.26C365.453 267.364 368.794 267.226 371.002 265.951L401.094 248.577C402.81 247.586 403.331 246.202 402.584 245.115C402.284 245.598 401.786 246.062 401.094 246.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.448 259.859C391.448 260.662 390.884 261.638 390.189 262.039C389.494 262.44 388.93 262.115 388.93 261.312C388.93 260.509 389.494 259.533 390.189 259.132C390.884 258.731 391.448 259.056 391.448 259.859Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.497 257.521C395.497 258.324 394.934 259.3 394.239 259.701C393.544 260.102 392.979 259.777 392.979 258.974C392.979 258.171 393.544 257.195 394.239 256.794C394.934 256.393 395.497 256.718 395.497 257.521Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.547 255.183C399.547 255.986 398.983 256.962 398.288 257.363C397.593 257.764 397.029 257.439 397.029 256.636C397.029 255.833 397.593 254.857 398.288 254.456C398.984 254.054 399.547 254.38 399.547 255.183Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.383 255.105L350.8 246.685C349.905 246.168 350.017 245.266 351.051 244.669L365.133 236.539C366.167 235.942 367.73 235.878 368.625 236.394L383.208 244.814C384.103 245.331 383.991 246.233 382.957 246.83L368.876 254.96C367.841 255.557 366.278 255.622 365.383 255.105Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.778 248.055L364.76 246.89C364.636 246.818 364.652 246.694 364.795 246.611L366.743 245.486C366.886 245.404 367.102 245.395 367.226 245.466L369.244 246.631C369.368 246.703 369.352 246.827 369.209 246.91L367.261 248.035C367.118 248.118 366.902 248.127 366.778 248.055Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.799 246.685L350.84 246.709C350.908 246.66 350.971 246.61 351.049 246.565L365.131 238.435C366.165 237.838 367.728 237.774 368.623 238.29L383.165 246.686C383.99 246.095 384.033 245.291 383.206 244.814L368.623 236.394C367.728 235.877 366.165 235.942 365.131 236.539L351.049 244.669C350.016 245.266 349.904 246.168 350.799 246.685Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.103 188.067L307.714 131.67C302.424 128.606 293.175 128.976 287.057 132.497L82.6644 250.126C76.5464 253.647 75.8744 258.985 81.1644 262.049L178.553 318.446C183.843 321.51 193.091 321.14 199.21 317.618L403.603 199.991C409.722 196.47 410.393 191.131 405.103 188.067Z",
    fill: "#7DC3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.579 308.474C183.907 308.474 180.386 307.709 177.7 306.155L80.3106 249.758C77.4586 248.106 75.8896 245.739 75.8926 243.095C75.8976 240.038 78.0556 237.044 81.8136 234.881L286.207 117.253C292.898 113.401 302.72 113.04 308.569 116.427L405.959 172.824C408.811 174.476 410.38 176.842 410.376 179.486C410.372 182.543 408.214 185.537 404.455 187.7L200.063 305.328C196.444 307.411 191.907 308.474 187.579 308.474ZM298.739 117.546C294.967 117.546 290.962 118.45 287.908 120.208L83.5156 237.836C80.8806 239.353 79.3056 241.32 79.3036 243.1C79.3006 244.862 80.7806 246.088 82.0206 246.807L179.41 303.203C184.14 305.943 192.82 305.563 198.362 302.373L402.754 184.745C405.39 183.228 406.964 181.261 406.967 179.481C406.969 177.719 405.49 176.493 404.25 175.775L306.86 119.378C304.736 118.147 301.815 117.546 298.739 117.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72 283.789L74.3672 225.096C71.0372 223.167 69.4852 220.567 69.5962 217.863L69.5732 217.87L69.6142 203.164L75.2512 209.767C75.6162 209.526 75.9852 209.285 76.3852 209.055L283.723 89.7317C291.954 84.9947 304.397 84.4957 311.515 88.6187L411.445 146.487C413.467 144.273 417.708 139.596 417.708 139.596L417.66 153.982L417.658 153.98C417.808 157.223 415.499 160.678 410.851 163.353L203.512 282.676C195.281 287.413 182.838 287.911 175.72 283.789Z",
    fill: "url(#paint8_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.915 247.782L126.752 251.152C127.527 251.6 128.156 251.125 128.156 250.091C128.156 249.057 127.527 247.857 126.752 247.409L120.915 244.039C120.14 243.591 119.511 244.066 119.511 245.1C119.512 246.134 120.14 247.335 120.915 247.782Z",
    fill: "#173D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.723 89.7317C291.955 84.9947 304.397 84.4957 311.515 88.6187L411.445 146.487C413.467 144.272 417.708 139.596 417.708 139.596L417.66 153.982L417.658 153.98C417.808 157.223 415.499 160.678 410.851 163.353L203.513 282.676C199.219 285.147 193.781 286.453 188.548 286.563L188.745 144.391L283.723 89.7317Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.911 132.525L311.557 73.8316C304.44 69.7096 291.997 70.2076 283.765 74.9446L76.4279 194.268C68.1969 199.005 67.2929 206.187 74.4099 210.31L175.763 269.003C182.88 273.125 195.323 272.627 203.555 267.89L410.892 148.567C419.125 143.829 420.028 136.647 412.911 132.525Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.687 270.572L74.3337 211.88C70.6627 209.754 69.1427 206.814 69.6437 203.816C69.8237 206.252 71.3857 208.558 74.4107 210.311L175.764 269.004C182.881 273.126 195.324 272.628 203.556 267.891L410.894 148.568C414.881 146.274 417.131 143.407 417.602 140.591C417.845 143.885 415.549 147.415 410.817 150.138L203.479 269.459C195.247 274.196 182.804 274.695 175.687 270.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.103 134.838L307.714 78.4406C302.424 75.3766 293.175 75.7476 287.057 79.2686L82.6644 196.897C76.5464 200.418 75.8744 205.756 81.1644 208.82L178.553 265.217C183.843 268.281 193.091 267.911 199.21 264.389L403.603 146.761C409.722 143.24 410.393 137.902 405.103 134.838Z",
    fill: "url(#paint9_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.086 235.926L134.363 196.248L138.75 193.716L207.473 233.393L203.086 235.926Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.271 224.358L120.474 204.268L124.86 201.736L159.658 221.826L155.271 224.358Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.158 234.108L160.872 227.592L165.259 225.059L176.544 231.575L172.158 234.108Z",
    fill: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.196 243.944L177.91 237.428L182.297 234.896L193.582 241.412L189.196 243.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.66 216.563L127.419 200.258L131.806 197.726L160.047 214.031L155.66 216.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.134 236.467L161.893 220.162L166.279 217.629L194.52 233.934L190.134 236.467Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.226 201.613C167.813 202.429 165.522 202.429 164.108 201.613C162.695 200.797 162.695 199.474 164.108 198.658C165.521 197.842 167.812 197.842 169.225 198.658C170.639 199.474 170.639 200.797 169.226 201.613Z",
    fill: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.871 206.028C175.458 206.844 173.167 206.844 171.753 206.028C170.34 205.212 170.34 203.889 171.753 203.073C173.166 202.257 175.457 202.257 176.871 203.073C178.285 203.889 178.285 205.212 176.871 206.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.519 210.442C183.106 211.258 180.815 211.258 179.402 210.442C177.989 209.626 177.989 208.303 179.402 207.487C180.815 206.671 183.106 206.671 184.52 207.487C185.932 208.304 185.932 209.626 184.519 210.442Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.166 214.857C190.753 215.673 188.462 215.673 187.048 214.857C185.635 214.041 185.635 212.718 187.048 211.902C188.461 211.086 190.752 211.086 192.166 211.902C193.579 212.718 193.579 214.041 192.166 214.857Z",
    fill: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.813 219.272C198.4 220.088 196.109 220.088 194.695 219.272C193.282 218.456 193.282 217.133 194.695 216.317C196.108 215.501 198.399 215.501 199.813 216.317C201.226 217.133 201.226 218.456 199.813 219.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.513 135.272L341.942 128.592L346.439 125.995L358.01 132.676L353.513 135.272Z",
    fill: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.626 144.575L358.055 137.894L362.552 135.298L374.123 141.978L369.626 144.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.83 105.153L290.259 98.4727L294.757 95.8757L306.328 102.557L301.83 105.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.934 142.005L334.822 132.703L339.32 130.106L355.432 139.409L350.934 142.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.505 148.686L355.435 144.604L359.933 142.007L367.003 146.089L362.505 148.686Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.668 203.225L188.004 148.635L215.592 132.707L310.255 187.297L282.668 203.225Z",
    fill: "#082C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.097 204.683C282.845 204.683 282.594 204.618 282.369 204.489L187.706 149.899C187.255 149.638 186.977 149.157 186.977 148.635C186.976 148.115 187.254 147.633 187.705 147.372L215.293 131.444C215.744 131.182 216.3 131.183 216.751 131.443L311.414 186.033C311.865 186.294 312.143 186.775 312.143 187.297C312.144 187.818 311.866 188.299 311.415 188.56L283.827 204.488C283.601 204.618 283.349 204.683 283.097 204.683ZM191.352 148.634L283.097 201.541L307.767 187.298L216.022 134.391L191.352 148.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.597 159.836C231.951 159.836 231.427 159.313 231.427 158.666V121.715C231.427 121.069 231.95 120.545 232.597 120.545C233.244 120.545 233.767 121.068 233.767 121.715V158.666C233.767 159.313 233.243 159.836 232.597 159.836Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.812 117.527V142.491C226.812 143.346 227.378 144.2 228.507 144.852C230.766 146.156 234.427 146.156 236.686 144.852C237.816 144.2 238.38 143.345 238.38 142.491V117.527H226.812Z",
    fill: "url(#paint10_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.812 121.633V130.081C230.207 131.632 234.986 131.632 238.382 130.081V121.632C234.986 120.083 230.207 120.083 226.812 121.633Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.97 82.7336H223.224V121.888C223.224 123.273 224.139 124.658 225.969 125.714C229.629 127.827 235.564 127.827 239.224 125.714C241.054 124.657 241.969 123.272 241.969 121.887V82.7336H241.97Z",
    fill: "url(#paint11_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.974 138.695C230.974 139.843 230.168 140.309 229.173 139.735C228.178 139.161 227.372 137.765 227.372 136.616C227.372 135.468 228.178 135.002 229.173 135.577C230.168 136.151 230.974 137.547 230.974 138.695Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.945 180.847C268.298 180.847 267.775 180.324 267.775 179.677V142.726C267.775 142.08 268.298 141.556 268.945 141.556C269.591 141.556 270.115 142.08 270.115 142.726V179.677C270.115 180.323 269.592 180.847 268.945 180.847Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.161 138.538V163.502C263.161 164.357 263.726 165.211 264.855 165.863C267.114 167.167 270.776 167.167 273.035 165.863C274.165 165.211 274.729 164.356 274.729 163.502V138.538H263.161Z",
    fill: "url(#paint12_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.161 142.644V151.092C266.556 152.643 271.335 152.643 274.73 151.092V142.643C271.335 141.094 266.556 141.094 263.161 142.644Z",
    fill: "#396CAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.318 103.745H259.572V142.899C259.572 144.284 260.487 145.669 262.317 146.725C265.977 148.839 271.912 148.839 275.572 146.725C277.403 145.668 278.317 144.283 278.317 142.898V103.745H278.318Z",
    fill: "url(#paint13_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.324 159.706C267.324 160.854 266.518 161.32 265.523 160.746C264.529 160.172 263.722 158.776 263.722 157.627C263.722 156.479 264.528 156.013 265.523 156.588C266.517 157.162 267.324 158.558 267.324 159.706Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.669 54.3924L221.553 40.0764C221.553 40.0764 220.617 54.3634 220.617 54.3924C220.617 54.4214 206.322 58.8204 206.322 58.8204L196.669 54.3924Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.967 136.792C329.967 126.744 322.913 114.527 314.211 109.503C312.317 108.41 310.509 107.772 308.827 107.508C306.318 94.3225 297.143 80.3195 286.204 74.0035C282.914 72.1035 279.785 71.0885 276.946 70.8705C275.452 54.8885 264.34 36.7265 250.846 28.9355C243.797 24.8655 237.402 24.3845 232.683 26.8765L232.684 26.8645L232.455 26.9965C232.334 27.0635 232.215 27.1325 232.096 27.2025L217.423 35.8685L222.299 39.7195C217.922 41.6325 215.156 46.5405 215.156 53.7965C215.156 67.1765 224.55 83.4475 236.138 90.1375L307.672 141.219L309.877 156.105L325.335 147.001C325.349 146.993 325.363 146.985 325.376 146.977L325.469 146.922L325.467 146.919C328.25 145.245 329.967 141.747 329.967 136.792Z",
    fill: "url(#paint14_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.882 47.9045L249.559 28.2275C243.021 24.8185 237.114 24.5365 232.684 26.8755L232.685 26.8635L232.456 26.9955C232.335 27.0625 232.216 27.1315 232.098 27.2015L217.425 35.8675L222.3 39.7185C219.241 41.0565 216.972 43.8615 215.882 47.9045Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.076 105.79L302.649 91.3705C298.434 84.0815 292.631 77.7125 286.206 74.0035C285.356 73.5125 284.517 73.0835 283.69 72.7085L252.435 90.9865L278.076 105.79Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.348 37.4785L235.299 43.8005L255.354 31.9885C253.889 30.8505 252.386 29.8225 250.849 28.9355C248.42 27.5335 246.072 26.5675 243.841 25.9915L224.348 37.4785Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.937 87.1274L280.325 98.6834L287.146 106.291L304.95 95.7794C303.542 92.7644 301.85 89.8494 299.937 87.1274Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.807 118.577C296.913 117.483 295.105 116.845 293.423 116.582C290.914 103.397 281.739 89.3935 270.8 83.0775C267.51 81.1775 264.38 80.1625 261.542 79.9445C260.048 63.9625 248.936 45.8005 235.442 38.0095C220.93 29.6315 209.166 36.4225 209.166 53.1795C209.166 53.7475 209.182 54.3215 209.209 54.8975C198.597 49.9755 190.306 55.5215 190.306 68.0915C190.306 81.4715 199.7 97.7425 211.288 104.433L298.807 154.962C307.509 159.986 314.563 155.913 314.563 145.866C314.563 135.819 307.509 123.601 298.807 118.577Z",
    fill: "url(#paint15_linear_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.209 54.8976C209.182 54.3216 209.166 53.7476 209.166 53.1796C209.166 53.1556 209.167 53.1326 209.167 53.1086C203.304 50.8286 198.266 51.8216 195.104 55.4796C198.54 52.6516 203.535 52.2656 209.209 54.8976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.087 117.327C298.193 116.234 296.385 115.595 294.703 115.332C292.194 102.147 283.02 88.1445 272.08 81.8285C268.79 79.9285 265.661 78.9135 262.822 78.6955C261.328 62.7135 250.216 44.5515 236.722 36.7605C227.681 31.5405 219.708 32.2105 214.98 37.5085C219.797 33.3925 227.17 33.2345 235.441 38.0095C248.935 45.8005 260.047 63.9625 261.541 79.9445C264.379 80.1625 267.508 81.1785 270.799 83.0775C281.739 89.3935 290.913 103.395 293.422 116.581C295.104 116.845 296.912 117.482 298.806 118.576C307.508 123.6 314.562 135.818 314.562 145.865C314.562 149.491 313.633 152.325 312.05 154.247C314.41 152.429 315.844 149.133 315.844 144.616C315.843 134.569 308.789 122.351 300.087 117.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.359 58.8886L213.938 61.9396L213.603 54.6956C213.579 54.1866 213.565 53.6816 213.565 53.1796C213.565 46.7136 215.517 42.0256 219.062 39.9786C222.607 37.9336 227.644 38.5866 233.244 41.8196C245.287 48.7726 255.794 65.6996 257.163 80.3546L257.508 84.0466L261.205 84.3306C263.478 84.5046 265.966 85.3646 268.601 86.8876C278.167 92.4106 286.789 105.245 289.102 117.404L289.681 120.448L292.742 120.927C293.961 121.118 295.262 121.609 296.608 122.387C303.956 126.63 310.164 137.382 310.164 145.866C310.164 149.041 309.284 151.371 307.748 152.258C306.214 153.143 303.756 152.742 301.006 151.154L213.486 100.625C203.305 94.7466 194.703 79.8486 194.703 68.0916C194.703 63.4786 196.063 59.9636 198.436 58.4486C199.412 57.8256 200.593 57.5156 201.924 57.5156C203.545 57.5156 205.388 57.9746 207.359 58.8886Z",
    fill: "url(#paint16_radial_2214_12086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.038 113.739L253.346 112.58L251.073 110.858L251.038 113.739Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.104 82.5524L246.345 81.4194L246.386 82.5924L244.104 82.5524Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.624 106.449L259.963 105.273L255.461 100.991L257.624 106.449Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.671 112.506L241.741 106.068C241.186 105.741 240.738 104.918 240.74 104.23L240.776 91.5754L253.716 99.1964L253.68 111.851C253.677 112.54 253.225 112.833 252.671 112.506Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.321 81.4334L234.515 89.0304C234.014 89.3524 234.419 90.5544 235.179 91.0024L247.236 98.1034L259.293 105.204C260.054 105.652 260.464 104.931 259.966 104.02L248.243 82.5664C247.738 81.6394 246.831 81.1044 246.321 81.4334Z",
    fill: "#5793CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.327 113.686L239.397 107.248C238.842 106.921 238.394 106.098 238.396 105.41L238.433 92.7554L251.373 100.376L251.336 113.031C251.333 113.72 250.881 114.013 250.327 113.686Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.977 82.6135L232.171 90.2095C231.67 90.5325 232.075 91.7335 232.836 92.1815L244.893 99.2825L256.95 106.383C257.711 106.831 258.121 106.11 257.623 105.199L245.9 83.7455C245.394 82.8195 244.487 82.2855 243.977 82.6135Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.529 211.291L174.328 171.915L176.137 170.87L244.339 210.246L242.529 211.291Z",
    fill: "#79B1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.332 185.758L173.342 172.484L177.125 170.3L200.115 183.573L196.332 185.758Z",
    fill: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.426 186.479L194.459 185.933L200.402 182.502L201.37 183.048L195.426 186.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.951 229.948C406.951 231.809 405.644 234.073 404.032 235.004C402.42 235.935 401.113 235.18 401.113 233.319C401.113 231.457 402.42 229.194 404.032 228.263C405.644 227.332 406.951 228.087 406.951 229.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.004 225.299C415.004 227.16 413.697 229.424 412.085 230.355C410.473 231.286 409.166 230.531 409.166 228.67C409.166 226.809 410.473 224.545 412.085 223.614C413.697 222.683 415.004 223.438 415.004 225.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.951 220.649C406.951 222.51 405.644 224.774 404.032 225.705C402.42 226.636 401.113 225.881 401.113 224.02C401.113 222.159 402.42 219.895 404.032 218.964C405.644 218.033 406.951 218.788 406.951 220.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.004 216C415.004 217.861 413.697 220.125 412.085 221.056C410.473 221.987 409.166 221.232 409.166 219.371C409.166 217.51 410.473 215.246 412.085 214.315C413.697 213.384 415.004 214.139 415.004 216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.748 46.5547L288.91 49.9257V43.1837L294.748 39.8137V46.5547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85 41.8186L297.012 45.1886V38.4476L302.85 35.0776V41.8186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.798 55.3006L288.96 58.6706V51.9296L294.798 48.5596V55.3006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85 50.6516L297.012 54.0216V47.2806L302.85 43.9106V50.6516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.862 344.647C196.625 344.647 196.385 344.591 196.161 344.474C195.418 344.086 195.131 343.169 195.518 342.427C197.058 339.479 199.317 336.994 201.715 335.61C203.224 334.74 204.689 334.338 206.082 334.401C208.044 334.505 210.473 333.028 212.599 330.468C213.789 329.033 215.153 327.852 216.54 327.05C218.047 326.18 219.511 325.776 220.908 325.842C222.819 325.953 225.297 324.471 227.423 321.909C228.63 320.454 229.956 319.305 231.364 318.491C232.873 317.621 234.359 317.211 235.73 317.282C237.715 317.369 240.123 315.91 242.248 313.349C243.438 311.914 244.802 310.733 246.189 309.931C248.414 308.647 250.633 308.367 252.437 309.156C253.205 309.49 253.557 310.383 253.223 311.152C252.888 311.919 251.994 312.267 251.226 311.938C250.327 311.543 249.078 311.767 247.706 312.559C246.625 313.183 245.545 314.126 244.581 315.287C241.809 318.628 238.526 320.446 235.58 320.313C234.801 320.261 233.861 320.552 232.881 321.119C231.801 321.743 230.72 322.686 229.756 323.847C226.983 327.189 223.669 329.006 220.756 328.873C219.972 328.819 219.035 329.111 218.057 329.678C216.976 330.302 215.896 331.245 214.932 332.406C212.159 335.747 208.872 337.561 205.931 337.432C205.159 337.376 204.212 337.67 203.232 338.238C201.319 339.342 199.487 341.382 198.207 343.832C197.938 344.351 197.409 344.647 196.862 344.647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2214_12086",
    x: 0,
    y: 0,
    width: 471,
    height: 378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2214_12086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2214_12086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.018 97.9345) scale(33.6687 33.6687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#274F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2214_12086",
    x1: 105.566,
    y1: 85.7175,
    x2: 165.144,
    y2: 85.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    stopColor: "#D0EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#C5E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6745,
    stopColor: "#B2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#98C4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86B8E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.6129 63.0938) scale(60.8593 60.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.4602 294.158) scale(33.6687 33.6687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#274F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2214_12086",
    x1: 55.0079,
    y1: 281.941,
    x2: 114.585,
    y2: 281.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    stopColor: "#D0EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#C5E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6745,
    stopColor: "#B2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#98C4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86B8E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0546 259.318) scale(60.8594 60.8594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.068 243.1) scale(39.3915 39.3915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2214_12086",
    x1: 340.503,
    y1: 230.47,
    x2: 402.206,
    y2: 267.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2009,
    stopColor: "#D0EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3874,
    stopColor: "#C5E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#B2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7444,
    stopColor: "#98C4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8423,
    stopColor: "#86B8E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.641 279.703) scale(142.083 142.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#396CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3588,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699DD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(407.367 138.868) scale(236.207 236.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4231,
    stopColor: "#153B76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8152,
    stopColor: "#0E336B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092E63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.094 141.261) scale(10.8103 10.8103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.048 129.657) scale(17.0934 17.0934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.443 162.271) scale(10.8104 10.8104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.397 150.667) scale(17.0935 17.0935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#6396CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#5184BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396CAA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.562 90.7283) scale(61.5198 61.5198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6412,
    stopColor: "#3668A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A1B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2214_12086",
    x1: 190.305,
    y1: 95.7676,
    x2: 314.563,
    y2: 95.7676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    stopColor: "#D0EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#C5E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6745,
    stopColor: "#B2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#98C4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86B8E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2214_12086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.415 142.184) scale(124.401 124.401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274F89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCloudVisibility);
export default __webpack_public_path__ + "static/media/MultiCloudVisibility.f14ff411a49cb70566cdcd4549e7f5f4.svg";
export { ForwardRef as ReactComponent };